import Xlsx from 'xlsx';
import { useSelector } from "react-redux";
import { WebAppSettings } from "utils/web-app-settings";
import { useMemo } from 'react';
export const UserIdDescriptionConfigUtil = {
    parseCsvContent(csvContent) {
        let res = {
            descriptionFieldList: [],
            userIdList: [],
            userIdToDescKeyValueList: {},
            errorMessage: '',
        };
        try {
            if (!(csvContent || '').trim()) {
                return res;
            }
            if (csvContent.length > 5 * 1024 * 1024) {
                res.errorMessage = '内容过长，最大支持5MB配置数据。';
                return res;
            }
            const wb = Xlsx.read(csvContent, { type: 'binary' });
            let json = Xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, raw: false });
            json = (json || []).filter(row => row.length > 0);
            if (json.length <= 1) {
                res.errorMessage = '内容格式不合法。必须有头部及至少一行数据行。';
                return res;
            }
            let [header, ...body] = json;
            if (header.length <= 1) {
                res.errorMessage = '内容格式不合法。头部必须有至少包含两列，其中第一列是用户ID';
                return res;
            }
            if (header.length > 6) {
                res.errorMessage = '最多支持5个描述列。';
                return res;
            }
            const validBody = body.filter(row => row && row.length >= 2);
            const descriptionFieldList = header.slice(1);
            const userIdList = validBody.map(row => row[0]);
            validBody.forEach(row => {
                const [userId, ...fieldValues] = row;
                res.userIdToDescKeyValueList[userId] = descriptionFieldList.map((field, i) => {
                    return {
                        key: field,
                        value: fieldValues[i] || '',
                    };
                });
            });
            res.descriptionFieldList = descriptionFieldList;
            res.userIdList = userIdList;
            return res;
        }
        catch (e) {
            console.error(e);
            res.errorMessage = '解析CSV时发生异常';
            return res;
        }
    },
    useCurrentAppParseCsvContentResult() {
        const appId = useSelector((state) => state.app.get('current').get('appId'));
        const webAppSettings = useSelector((state) => state.app.get('appIdToWebAppSettings')[appId] || {});
        const configCsvText = (webAppSettings || {})[WebAppSettings.keys.userIdDescriptionConfigCsvText] || '';
        return useMemo(() => {
            return UserIdDescriptionConfigUtil.parseCsvContent(configCsvText);
        }, [configCsvText]);
    },
};
